
import React from "react";

const RootImage = ({ style }) => (
    <img style={style} src="/logo512.png" alt="My Image" />
);


export default RootImage;
